import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const API_URL = '/api';
export const courseApi = createApi({
    reducerPath: 'courseApi',
    baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
    endpoints: (builder) => ({
        AddCourse: builder.mutation({
            query: ({ Token, data }) => ({
                url: '/course',
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
                body: data,
            }),
            // Use 'Projects' for providesTags and invalidatesTags
            providesTags: ['courses'],
            invalidatesTags: ['courses'],
        }),
        getAllCourse: builder.query({
            query: () => ({
                url: '/course',
                method: 'GET',
            }),
            providesTags : ['courses']
        }),
        UpadteCourse: builder.mutation({
            query: ({ courseId, Token, data }) => ({
                url: `/course/${courseId}`,
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
                body: data,
            }),
            // Use 'Projects' for invalidatesTags
            invalidatesTags: ['courses'],
        }),
        DeleteCourse: builder.mutation({
            query: ({ courseId, Token }) => ({
                url: `/course/${courseId}`,
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            }),
            // Use 'Projects' for invalidatesTags
            invalidatesTags: ['courses'],
        }),
    }),
});

export const {
    useGetAllCourseQuery, useAddCourseMutation, useDeleteCourseMutation, useUpadteCourseMutation
} = courseApi;
